import type { GetComplianceMonitoringAssessmentCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetComplianceMonitoringAssessmentCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetComplianceMonitoringAssessmentCount = createQueryHook<
  Record<string, never>,
  number,
  GetComplianceMonitoringAssessmentCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.oversight.complianceMonitoringAssessmentCount.queryOptions(),
  // Pass the count straight through (not `data ?? 0`): the createQueryHook
  // factory already surfaces undefined while loading, so a genuine 0 must
  // stay 0 rather than be masked by a coerced fallback.
  mapTrpcDataToGraphQL: (data) => ({
    compliance_monitoring_assessment_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetComplianceMonitoringAssessmentCountDocument,
});
